module.exports = __webpack_public_path__ + "static/img/14000373.5db89426.png";